export const FEATURE_FLAG_NAMES = {
  SUBTITLES_OPENAI: 'ff_subtitles_openai',
  SSE_ON_PROJECT_PAGE: 'ff_sse_on_project_page',
  MESSAGING_PROJECT: 'ff_messaging_project',
  SHOPPABLE_ADMIN_WIDGET: 'ff_shoppable_admin_widget',
  USM_DASHBOARD_SUBTITLES: 'ff_usm_dashboard_subtitles',
  SHOW_COMPANY_CONFIG: 'ff_show_company_config',
}
